var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubePostUnlike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.668,
    height: 14.243,
    viewBox: "0 0 15.668 14.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.849,
    height: 8.546,
    transform: "translate(12.819 0)",
    fill: "#818c9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,29.167a1.424,1.424,0,0,0,1.424,1.424h4.5l-.68,3.255a1.139,1.139,0,0,0-.025.224,1.066,1.066,0,0,0,.313.755l.758.751,4.69-4.69a1.433,1.433,0,0,0,.417-1.008V22.757a1.424,1.424,0,0,0-1.424-1.424h-6.41a1.42,1.42,0,0,0-1.31.869L128.1,27.223a1.424,1.424,0,0,0-.1.52v1.364l.007.007Z",
    transform: "translate(-128 -21.333)",
    fill: "#818c9f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubePostUnlike);
export default __webpack_public_path__ + "static/media/youtube-post-unlike.ddb2f2b5b1c5fcb5cbe9b43eed909b9d.svg";
export { ForwardRef as ReactComponent };